export default __webpack_public_path__ + "static/logo-capeb-2095ebb291043da7ed04e0d94e6d57db.jpg";